<rms-mod width="100%">
  <h3 style="margin:0 0 10px 0">Container {{ containerID }}</h3>
  @if (canReopen) {
    <p>Return this unshipped load to holding to adjust quantities or its destination.</p>
    <button type="button" mat-stroked-button [disabled]="saving" (click)="reopen()">{{ saving ? 'Returning…' : 'Return load to holding' }}</button>
  }
  <div class="tank-list">
    @if (loading) {
    <p class="empty-state">Loading items…</p>
    }
    @for (item of items; track item.InventoryID) {
    <div class="inventory-card">
      <div class="card-details">
        <span>Ref # {{ item.InventoryID }} &middot; {{ item.BagsOrdered }} bags</span>
        @if (item.InventoryTypeName) {
        <span class="coffee-name">{{ item.InventoryTypeName }}</span>
        }
        @if (item.Marks || item.SupplierReffNumber) {
        <span class="meta">
          @if (item.Marks) { Marks: {{ item.Marks }} }
          @if (item.Marks && item.SupplierReffNumber) { &middot; }
          @if (item.SupplierReffNumber) { Supplier Ref: {{ item.SupplierReffNumber }} }
        </span>
        }
        @if (item.DateIn) {
        <span class="meta">Source date in: {{ item.DateIn | date:'MM/dd/yyyy' }}</span>
        }
        @if (item.OriginName) {
        <span class="origin-chip"><mat-icon inline>north_east</mat-icon> From {{ item.OriginName }}</span>
        }
      </div>
    </div>
    }
    @if (!loading && !items.length) {
    <p class="empty-state">No items found for this container.</p>
    }
  </div>
</rms-mod>
